import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal, Button, Row, Spin, Select, Switch } from 'antd';
import { MinusOutlined } from '@ant-design/icons';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import Loading from 'components/Loading';
import EditorTexto from 'components/EditorTexto';
import {
  fetchNotificationApp,
  fetchUpdateDadosMinimizados,
  fetchStatusModalEncaminhar,
} from 'store/fetchActions/fetchApp';
import { fetchGetTodosAtendentes } from 'store/fetchActions/fetchAtendente';
import { formatterJustificativaEncaminharNull } from 'utils/formatter/justificativa';
import { changeInput } from 'utils/formUtils';
import { ALERTA, ENUM_MODAL, MSG_FORMULARIO_ENCAMINHADO, ENUM_CARGO } from 'utils/consts';
import { fetchBuscarSetores } from 'store/fetchActions/fetchSetores';
import { requerimentos } from 'routes/paths';
import ButtonEncaminhar from './Buttons';
import * as Style from 'components/Style';

export const ModalGenericoEncaminhar = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { Option } = Select;

  const unitaryTests = useSelector(state => state.app.unitaryTests);
  const modalAcessoNegado = useSelector(state => state.app.modalAcessoNegado);
  const thisModalState = useSelector(state => state.app.modalEncaminhar);
  const dadosMinimizados = useSelector(state => state.app.dadosMinimizados);

  const [loading, setLoading] = React.useState(false);
  const [isEncaminharSetor, setIsEncaminharSetor] = React.useState(true);
  const [setoresExibir, setSetoresExibir] = React.useState([]);
  const [atendentesExibir, setAtendentesExibir] = React.useState([]);
  const [valorExibirInput, setValorExibirInput] = React.useState(null);

  const {
    setValue,
    getValues,
    setError,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: formatterJustificativaEncaminharNull(dadosMinimizados, thisModalState?.props?.justificativa),
  });

  React.useEffect(() => {
    //NÃO ABRIR ESSE MODAL SE O MODAL DE ACESSO NEGADO ESTIVER ABERTO
    if (modalAcessoNegado?.isOpen && thisModalState?.isOpen) {
      dispatch(fetchStatusModalEncaminhar(false, ''));
    }
  }, [dispatch, modalAcessoNegado, thisModalState]);

  React.useEffect(() => {
    if (unitaryTests || !thisModalState?.isOpen) return;
    dispatch(fetchBuscarSetores()).then(resposta => setSetoresExibir(resposta));
    dispatch(fetchGetTodosAtendentes()).then(resposta => setAtendentesExibir(resposta));
  }, [dispatch, unitaryTests, thisModalState]);

  React.useEffect(() => {
    if (!dadosMinimizados?.nameModal) {
      reset();
    }
    if (dadosMinimizados?.nameModal && thisModalState?.isOpen) {
      handleChange({ target: { value: thisModalState?.props?.justificativa, name: 'justificativa' } });
    }
    // eslint-disable-next-line
  }, [dadosMinimizados]);

  const onClose = rotaRedirect => {
    reset();
    if (rotaRedirect) history.push(rotaRedirect);
    dispatch(fetchUpdateDadosMinimizados({}));
    dispatch(fetchStatusModalEncaminhar(false, ''));
    setValorExibirInput(null);
    setIsEncaminharSetor(true);
  };

  const onMinimize = () => {
    const dadosInputs = getValues();
    const dadosMinimizadosCompleto = {
      ...dadosMinimizados,
      justificativa: dadosInputs?.justificativa,
      arquivos: null,
      nameModal: thisModalState.title,
    };

    dispatch(fetchUpdateDadosMinimizados(dadosMinimizadosCompleto));
    dispatch(fetchStatusModalEncaminhar(false, ''));
  };

  const sucessoFinalizar = (mensagemExibir = MSG_FORMULARIO_ENCAMINHADO) => {
    dispatch(fetchStatusModalEncaminhar(false, ''));
    onClose(requerimentos);
    fetchNotificationApp(mensagemExibir, '', ALERTA.SUCESSO);
    setLoading(false);
  };

  const handleChange = e => {
    const { value, name } = e.target;
    changeInput(e, setValue, errors, setError);
    if (name === 'setorEncaminharId' || name === 'atendenteEncaminharId') setValorExibirInput(value);
  };

  const handleChangeSwitch = async statusSwitch => {
    setIsEncaminharSetor(statusSwitch);

    handleChange({ target: { name: 'atendenteEncaminharId', value: '' } });
    handleChange({ target: { name: 'setorEncaminharId', value: '' } });
    setValorExibirInput(null);
  };

  const renderSwitch = () => {
    if (thisModalState.title === ENUM_MODAL.ENCAMINHAR.ATENDENTE) return <></>;
    return (
      <>
        <Switch
          data-testid="switch-setor-atendente"
          checkedChildren="SETOR"
          unCheckedChildren="ATENDENTE"
          defaultChecked={isEncaminharSetor}
          onChange={statusSwitch => handleChangeSwitch(statusSwitch)}
          style={{ marginBottom: '10px' }}
        />
      </>
    );
  };

  const renderButtons = () => {
    return (
      <ButtonEncaminhar
        getValues={getValues}
        setExibirLoading={setLoading}
        sucessoFinalizar={sucessoFinalizar}
        setError={setError}
        isEncaminharSetor={isEncaminharSetor}
      />
    );
  };

  const getOptionsSelectSupervisorSetorial = () => {
    // EXIBIR OPÇÕES DO SELECT DO SUPERVISOR OU SUPERVISOR SETORIAL

    // IF - SE FOR PRA EXIBIR ATENDENTES
    if (!isEncaminharSetor) {
      return atendentesExibir?.map(item => {
        return (
          <>
            {item?.cargoId !== ENUM_CARGO.SUPERVISOR && (
              <Option key={`${item?.id}-${item.nome}`} value={item?.id}>
                {item?.nome}
              </Option>
            )}
          </>
        );
      });
    } else {
      // IF - SE FOR PRA EXIBIR SETORES
      return setoresExibir?.map(item => {
        return (
          <Option key={`${item?.id}-${item.nome}`} value={item?.id}>
            {item?.nome}
          </Option>
        );
      });
    }
  };

  const getOptionsSelectSupervisor = () => {
    // IF - SE FOR PRA EXIBIR ATENDENTES
    if (!isEncaminharSetor) {
      return atendentesExibir?.map(item => {
        return (
          <>
            {!item?.isSetorial && item?.cargoId === ENUM_CARGO.ATENDENTE && (
              <Option key={`${item?.id}-${item.nome}`} value={item?.id}>
                {item?.nome}
              </Option>
            )}
          </>
        );
      });
    } else {
      // IF - SE FOR PRA EXIBIR SETORES
      return setoresExibir?.map(item => {
        return (
          <Option key={`${item?.id}-${item.nome}`} value={item?.id}>
            {item?.nome}
          </Option>
        );
      });
    }
  };

  const renderInputAtendente = () => {
    return (
      <>
        <Select
          data-testid="select-atendente"
          name="setorEncaminharId"
          value={valorExibirInput}
          style={{ width: '100%' }}
          onChange={e => handleChange({ target: { name: 'setorEncaminharId', value: e } })}
        >
          {setoresExibir?.map(item => {
            return (
              <Option key={`setorEncaminharId-${item?.id}`} value={item?.id}>
                {item?.nome}
              </Option>
            );
          })}
        </Select>
        {errors?.setorEncaminharId && <Style.GlobalErro>{errors?.setorEncaminharId?.message}</Style.GlobalErro>}
      </>
    );
  };

  const renderInputSupervisor = () => {
    return (
      <>
        <p>{isEncaminharSetor ? 'Selecione um Setor' : 'Selecione um Atendente'}</p>
        <Select
          data-testid="select-supervisor"
          value={valorExibirInput}
          style={{ width: '100%' }}
          filterOption={(input, options) => options.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          onChange={e => {
            const nameInput = isEncaminharSetor ? 'setorEncaminharId' : 'atendenteEncaminharId';
            const event = { target: { name: nameInput, value: e } };
            handleChange(event);
          }}
          disabled={false}
          allowClear
          showSearch
          optionFilterProp={'children'}
          showArrow
        >
          {getOptionsSelectSupervisor()}
        </Select>
        {errors?.setorEncaminharId && <Style.GlobalErro>{errors?.setorEncaminharId?.message}</Style.GlobalErro>}
        {errors?.atendenteEncaminharId && <Style.GlobalErro>{errors?.atendenteEncaminharId?.message}</Style.GlobalErro>}
      </>
    );
  };

  const renderInputSupervisorSetorial = () => {
    return (
      <>
        <p>{isEncaminharSetor ? 'Selecione um Setor' : 'Selecione um Atendente'}</p>
        <Select
          data-testid="select-supervisor-setorial"
          value={valorExibirInput}
          style={{ width: '100%' }}
          onChange={e => {
            const nameInput = isEncaminharSetor ? 'setorEncaminharId' : 'atendenteEncaminharId';
            const event = { target: { name: nameInput, value: e } };
            handleChange(event);
          }}
        >
          {getOptionsSelectSupervisorSetorial()}
        </Select>
        {errors?.setorEncaminharId && <Style.GlobalErro>{errors?.setorEncaminharId?.message}</Style.GlobalErro>}
        {errors?.atendenteEncaminharId && <Style.GlobalErro>{errors?.atendenteEncaminharId?.message}</Style.GlobalErro>}
      </>
    );
  };

  const getInputSelect = () => {
    if (thisModalState.title === ENUM_MODAL.ENCAMINHAR.ATENDENTE) {
      return renderInputAtendente();
    }
    if (thisModalState.title === ENUM_MODAL.ENCAMINHAR.SUPERVISOR) {
      return renderInputSupervisor();
    }
    if (thisModalState.title === ENUM_MODAL.ENCAMINHAR.SUPERVISOR_SETORIAL) {
      return renderInputSupervisorSetorial();
    }
    return <></>;
  };

  const getFraseTitulo = () => {
    if (thisModalState.title === ENUM_MODAL.ENCAMINHAR.ATENDENTE) {
      return (
        <p data-testid="titulo-encaminhar">
          Escolha o <b>Setor</b> para encaminhar o requerimento, ao encaminhar, o atendente do setor será responsável
          por continuar o atendimento. A Justificativa será destinada somente ao setor selecionado.
        </p>
      );
    }

    return (
      <p data-testid="titulo-encaminhar">
        Escolha o <b>Setor</b> ou <b>Atendente</b> para encaminhar o requerimento, ao encaminhar, o atendente será
        responsável por continuar o atendimento. A Justificativa será destinada somente ao setor/atendente selecionado.
      </p>
    );
  };

  return (
    <Modal
      title={thisModalState?.title}
      centered
      visible={thisModalState?.isOpen}
      onCancel={onMinimize}
      closeIcon={<MinusOutlined data-testid="Minimizar_Icon" />}
      width={800}
      closable={true}
      destroyOnClose
      footer={[
        <Button key="back" onClick={onClose}>
          Fechar
        </Button>,
      ]}
    >
      <Loading>
        <Spin tip="Carregando..." spinning={loading}>
          <div>
            {getFraseTitulo()}
            <p style={{ margin: '5px 0' }}>
              Tamanho total da Justificativa <b>{`${watch('justificativa').length}/2000`}</b>
            </p>
            <br />
            {renderSwitch()}
            {getInputSelect()}
            <div style={{ marginTop: '10px' }}>
              <EditorTexto
                name="justificativa"
                tooltipSwitchText="Visualizar Justificativa"
                errors={errors}
                visualizarJustificativa={false}
                data={dadosMinimizados?.justificativa || thisModalState?.props?.justificativa}
                handleChange={handleChange}
              />
            </div>
            <Row style={{ marginTop: '30px' }}>{renderButtons()}</Row>
          </div>
        </Spin>
      </Loading>
    </Modal>
  );
};

export default ModalGenericoEncaminhar;
